import { render, staticRenderFns } from "./VipPurchaseDialog.vue?vue&type=template&id=51fde5a7&scoped=true"
import script from "./VipPurchaseDialog.vue?vue&type=script&lang=js"
export * from "./VipPurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./VipPurchaseDialog.vue?vue&type=style&index=0&id=51fde5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fde5a7",
  null
  
)

export default component.exports